import { Thead, Tbody, Tr, Th, Td, Table, Flex, Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { Link } from 'react-router-dom';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { jobStatusConfig } from '@/pages/ats-job-creation/utils/constants';

export const JobDetailsTable = ({ ats_applications }) => {
  const columnsConfig = [
    {
      headerText: 'Job name',
      width: 200,
      Cell: ({ item }) => {
        const { ats_job_name, ats_job_id, job_id, id } = item;
        const maxW = '200px';
        return (
          <Flex alignItems="center" gap="12px" maxW="100%">
            <Link
              to={`/jobs/${ats_job_id || job_id}?tab=candidates&appId=${id}`}
              target="_blank"
            >
              <TruncatedTextWithTooltip
                variant="link"
                text={ats_job_name}
                maxW={maxW}
                color="primary-600"
              />
            </Link>
          </Flex>
        );
      },
    },
    {
      headerText: 'Job status',
      width: 100,
      Cell: ({ item }) => {
        const { ats_job_status } = item;
        const { color, label } = jobStatusConfig[ats_job_status] || {};
        return (
          <Flex
            alignItems="center"
            border="1px solid"
            borderRadius="6px"
            p="2px 6px"
            borderColor="border-color"
            gap="6px"
            w="fit-content"
          >
            <Box w="8px" h="8px" bgColor={color} borderRadius="10px"></Box>
            <TruncatedTextWithTooltip
              text={label}
              maxW="70px"
              variant="heading_4"
              color="secondary-700"
            />
          </Flex>
        );
      },
    },
    {
      headerText: 'Application stage',
      width: 200,
      Cell: ({ item }) => {
        const { current_ats_stage_name } = item;
        return (
          <TruncatedTextWithTooltip
            text={current_ats_stage_name}
            maxW="150px"
            bgColor="secondary-50"
            borderRadius="xs"
            p="0.125em 0.5em"
            variant="heading_4"
            color="secondary-700"
            w="fit-content"
          />
        );
      },
    },
  ];

  return (
    <Table
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Thead
        className="records-table"
        bg="secondary-25"
        position="sticky"
        top="0"
        zIndex="1"
      >
        <Tr>
          {columnsConfig?.map?.((column, idx) => (
            <Th key={idx} py="12px" maxW="220px">
              <KText
                variant="heading_3"
                textTransform="none"
                color="primary-900"
              >
                {column?.headerText}
              </KText>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody className="records-table">
        {ats_applications?.map((item) => (
          <Tr key={item?.id}>
            {columnsConfig?.map((column, idx) => {
              const { Cell = () => <></> } = column;
              return (
                <Td key={idx} py="12px">
                  <Cell item={item} />
                </Td>
              );
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
